import { reduce } from 'lodash';

export const ACCOUNT_TYPES = [
  { icon: 'banking/standard-account', key: 'standard' },
  { icon: 'banking/graduate-account', key: 'graduate' },
  { icon: 'banking/student-account', key: 'student' },
  { icon: 'banking/senior-account', key: 'sixtyplus' }
];

export const CHARGES = [
  'fee_debit_card_amount', 'fee_contactless', 'tx_atm', 'tx_lodgement', 'fee_so_setup', 'fee_so_commission', 'tx_so',
  'fee_so_amend', 'fee_so_unpaid', 'fee_dd_setup', 'tx_dd', 'fee_dd_unpaid', 'fee_chq_unpaid',
  'fee_chq_unpaid_inward', 'fee_referral', 'fee_replace_loststolen_card', 'fee_stop_instruction',
  'fee_replace_pin', 'fee_credit_tfer', 'fee_dup_stmt'
];

export const USAGES = {
  atm_withdrawal: { default: 3, max: 25, step: 1 },
  atm_withdrawal_in_euros: { default: 250, max: 1000, step: 10 },
  lodgements: { default: 3, max: 30, step: 1 },
  chip_and_pin: { default: 5, max: 50, step: 5 },
  contactless: { default: 30, max: 150, step: 10 },
  direct_debit: { default: 10, max: 50, step: 1 },
  online_transactions: { default: 5, max: 20, step: 1 }
};

export const DEFAULT_USAGES = reduce(USAGES, (result, value, key) => {
  result[key] = value['default'];
  return result;
}, {});
